module.exports = __webpack_public_path__ + "img/no_person.80b24a05.png";